import React, { useState } from 'react';

const FDCalculator: React.FC = () => {
    const [depositAmount, setDepositAmount] = useState<number>(10000);
    const [tenureMonths, setTenureMonths] = useState<number>(3);
    const [rateOfInterest, setRateOfInterest] = useState<number>(6.3);
    const [typeOfDeposit, setTypeOfDeposit] = useState<string>('Cumulative');
    const [maturityAmount, setMaturityAmount] = useState<number | null>(null);
    const [totalInterest, setTotalInterest] = useState<number | null>(null);

    const calculateMaturityAmount = () => {
        const principal = depositAmount;
        const rate = rateOfInterest / 100;
        const time = tenureMonths / 12; // convert months to years
    
        let maturity = 0;
    
        if (typeOfDeposit === 'Annually') {
            const compoundingFrequency = 1; // Annually compounding
            maturity = principal * Math.pow(1 + rate / compoundingFrequency, compoundingFrequency * time);
        } else if (typeOfDeposit === 'Monthly') {
            const compoundingFrequency = 12; // Monthly compounding
            maturity = principal * Math.pow(1 + rate / compoundingFrequency, compoundingFrequency * time);
        } else if (typeOfDeposit === 'Quarterly') {
            const compoundingFrequency = 4; // Quaterly compounding
            maturity = principal * Math.pow(1 + rate / compoundingFrequency, compoundingFrequency * time);
        } else if (typeOfDeposit === 'Half-Yearly') {
            const compoundingFrequency = 2; // Half-Yearly compounding
            maturity = principal * Math.pow(1 + rate / compoundingFrequency, compoundingFrequency * time);
        }
    
        const interest = maturity - principal;
    
        setMaturityAmount(maturity);
        setTotalInterest(interest);
    };
    

    


    return (
        <div className="container">
            <h1>Fixed Deposit Calculator</h1>
            <div className="form-group">
                <label>Deposit Amount (₹):</label>
                <input
                    type="number"
                    className="form-control"
                    value={depositAmount}
                    onChange={(e) => setDepositAmount(Number(e.target.value))}
                />
            </div>

            <div className="form-group">
                <label>Tenure (In Months):</label>
                <input
                    type="number"
                    className="form-control"
                    value={tenureMonths}
                    onChange={(e) => setTenureMonths(Number(e.target.value))}
                />
            </div>

            <div className="form-group">
                <label>Rate Of Interest (%):</label>
                <input
                    type="number"
                    className="form-control"
                    value={rateOfInterest}
                    onChange={(e) => setRateOfInterest(Number(e.target.value))}
                />
            </div>

                <div className="form-group">
                <label>Type of Fixed Deposit (Compounding Frequency):</label>
                <div className="btn-group d-flex flex-wrap">
                    {[
                        { type: 'Annually' },
                        { type: 'Monthly' },
                        { type: 'Quarterly' },
                        { type: 'Half-Yearly' },
                    ].map(({ type }) => (
                        <button
                            key={type}
                            type="button"
                            className={`btn ${typeOfDeposit === type ? 'btn-primary' : 'btn-outline-primary'} m-1`}
                            onClick={() => setTypeOfDeposit(type)}
                        >
                            {type}
                        </button>
                    ))}
                </div>
            </div>

            <button className="btn btn-success mt-3" onClick={calculateMaturityAmount}>
                Calculate
            </button>

            {maturityAmount !== null && totalInterest !== null && (
                <div className="mt-4">
                    <h3>Maturity Amount: ₹{maturityAmount.toFixed(2)}</h3>
                    <h4>Total Interest Earned: ₹{totalInterest.toFixed(2)}</h4>
                </div>
            )}
        </div>
    );
};

export default FDCalculator;
